<template>
  <b-modal ref="errorDialog" title="Info" @ok="onUserConfirmation()">
    <p class="my-4">Oops, there was a problem sending data to BehaviorQuant! <br/> Please try again!</p>

    <template v-slot:modal-footer="{ ok }">
      <b-button @click="ok()"
                size="lg"
                :variant="colorVariant"
                pill
      >
        OK
      </b-button>
    </template>
  </b-modal>
</template>

<script>
  import colorVariantMixin from "@/components/mixins/colorVariantMixin";

  export default {
    name: "errorDialog",
    mixins: [colorVariantMixin],
    model: {
      event: "onUserConfirmation"
    },
    methods: {
      show() {
        this.$refs.errorDialog.show();
      },
      onUserConfirmation() {
        this.$emit("onUserConfirmation")
      }
    }
  }
</script>

<style scoped>

</style>
